import { type HTMLAttributes, type PropsWithChildren } from "react";

export interface BadgeProps
  extends PropsWithChildren<HTMLAttributes<HTMLDivElement>> {
  text?: string;
  color?: string;
  filled?: boolean;
  outline?: boolean;
}

const Badge: React.FC<PropsWithChildren<BadgeProps>> = ({
  children,
  color,
  text,
  filled,
  outline = true,
  ...rest
}) => {
  const badgeProps: any = {};
  color && (badgeProps["data-color"] = color);
  filled && (badgeProps["data-filled"] = "");
  outline && !filled && (badgeProps["data-outline"] = "");

  return (
    <badge {...rest} {...badgeProps}>
      <text data-ellipsis="" data-weight="600">
        {text || children} {/* NOSONAR */}
      </text>
    </badge>
  );
};

export default Badge;
